var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[(!_vm.loading)?_c('v-col',{attrs:{"cols":"12"}},[_c('ChoiceOptions',{attrs:{"choices":_vm.choices,"value":_vm.current?.id},on:{"selection":(val) => _vm.$emit("selection", val)}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }